module.exports = __webpack_public_path__ + "static/media/option-minus.5f06f2e8.svg";